module.exports = __webpack_public_path__ + "img/calculator-sign.56de2494.svg";